module.exports = __webpack_public_path__ + "img/nl.226f307f.svg";